import { Category } from 'src/app/models/category';

export class Channel {
    Id: number;
    UserId: number;
    ChannelUrl: string;
    Title: string;
    Categories: Category[];
    PublishDate: Date;
    ImageUrl: string;
    Active: boolean;
    Show: boolean;
    ModifiedDate: Date;
    CreatedDate: Date;
}